import { ShieldCheck } from 'lucide-react';
import { DEMO_MODE, demoLabel } from '@/platform/demo-mode';

/**
 * Small fixed pill shown only on demo deployments (VITE_DEMO_MODE set). Makes
 * it unmistakable that this is an isolated, safe demo — no production data,
 * no real emails/calls. Renders nothing outside demo mode.
 */
export function DemoModeBadge() {
  if (!DEMO_MODE) return null;
  return (
    <div className="pointer-events-none fixed bottom-3 left-3 z-50">
      <div className="pointer-events-auto flex items-center gap-1.5 rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1 text-[11px] font-medium text-primary shadow-sm backdrop-blur">
        <ShieldCheck className="h-3.5 w-3.5" aria-hidden />
        <span>Demo · {demoLabel()} · Safe mode</span>
      </div>
    </div>
  );
}
